
class DeliveryOrderCell extends UITableViewCell
{
    private referenceLabel:MUILabel = null;  
    private documentIDLabel:MUILabel = null;  
    private documentDateLabel:MUILabel = null;  
    private originNameLabel:MUILabel = null;

    awakeFromHTML(){        
        this.referenceLabel = MUIOutlet(this, "reference-lbl", "MUILabel");
        this.documentIDLabel = MUIOutlet(this, "document-id-lbl", "MUILabel");
        this.documentDateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.originNameLabel = MUIOutlet(this, "origin-lbl", "MUILabel");
    }

    set item (item:StockNote){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        this.referenceLabel.text = item.externalReference;
        this.documentIDLabel.text = item.documentID;
        this.documentDateLabel.text = ad.dateFormatter.stringFromDate(item.stockDate);
        this.originNameLabel.text = item.originName;
    }
}